import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { ItemType } from './draggable-wrapper-types.js';
import { DRAGGABLE_IDENTIFIER } from './utils.js';
function DraggableWrapper(props) {
    const dragCollect = (monitor) => ({
        isDragging: monitor.isDragging(),
    });
    const onDragEnd = (item, monitor) => {
        if (!monitor.didDrop()) {
            props.onReset();
            return;
        }
        props.onDragEnd(item[DRAGGABLE_IDENTIFIER], item.index);
    };
    const itemIndex = props.findItemIndex(props.item[DRAGGABLE_IDENTIFIER]);
    const dragItem = {
        [DRAGGABLE_IDENTIFIER]: props.item[DRAGGABLE_IDENTIFIER],
        index: itemIndex,
    };
    const [collected, drag] = useDrag({
        canDrag: props.canDrag ?? true,
        collect: dragCollect,
        end: onDragEnd,
        item: dragItem,
        type: ItemType.Item,
    });
    const dropHover = (item) => {
        if (item[DRAGGABLE_IDENTIFIER] === props.item[DRAGGABLE_IDENTIFIER]) {
            return;
        }
        const index = props.findItemIndex(props.item[DRAGGABLE_IDENTIFIER]);
        props.moveItem(item[DRAGGABLE_IDENTIFIER], index);
    };
    const [, drop] = useDrop({
        accept: ItemType.Item,
        hover: dropHover,
    });
    const style = {
        opacity: collected.isDragging ? .8 : 1,
    };
    return (React.createElement("div", { ref: node => drag(drop(node)), style: style }, props.children));
}
export { DraggableWrapper, };
//# sourceMappingURL=draggable-wrapper.js.map